module.exports = __webpack_public_path__ + "img/385.a8313b4e.jpg";